module.exports = __webpack_public_path__ + "static/media/flutter.10a5194f.png";